'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../../external/classnames/index.js');

var PropTypes = require('prop-types');

var Link = require('../../../primitives/Link/Link.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var SectionHeader = function SectionHeader(props) {
  var alt = props.alt,
      color = props.color,
      className = props.className,
      src = props.src,
      link = props.link,
      linkText = props.linkText,
      noContent = props.noContent,
      textAlign = props.textAlign,
      title = props.title,
      target = props.target;
  var bannerClasses = index['default']('lanl-section-header', color !== 'default' && "text-".concat(color), link && 'section-link', "text-".concat(textAlign), noContent && 'lanl-section-header-no-content', className);
  var linkClasses = index['default'](color !== 'default' && "text-".concat(color));

  var renderLink = function renderLink() {
    if (link) {
      return /*#__PURE__*/React__default['default'].createElement(Link.Link, {
        className: linkClasses,
        href: link,
        target: target
      }, linkText);
    } else {
      return null;
    }
  };

  var renderTitle = function renderTitle() {
    if (src) {
      return /*#__PURE__*/React__default['default'].createElement("img", {
        src: src,
        alt: alt
      });
    } else {
      return /*#__PURE__*/React__default['default'].createElement("h2", {
        className: "lanl-section-header-title"
      }, title);
    }
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: bannerClasses,
    "data-testid": "lanl-section-header"
  }, renderTitle(), renderLink());
};

SectionHeader.defaultProps = {
  color: 'default',
  noContent: false,
  target: '',
  textAlign: 'left'
};
SectionHeader.propTypes = {
  alt: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string,
  color: PropTypes__default['default'].oneOf(['default', 'white']),
  link: PropTypes__default['default'].string,
  linkText: PropTypes__default['default'].string,
  noContent: PropTypes__default['default'].bool,
  src: PropTypes__default['default'].string,
  target: PropTypes__default['default'].oneOf(['_blank', '_self', '_parent', '_top', '']),
  textAlign: PropTypes__default['default'].oneOf(['center', 'left', 'right']),
  title: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object])
};
exports.SectionHeader = SectionHeader;
exports['default'] = SectionHeader;